module.exports = __webpack_public_path__ + "img/KI.e298e81f.png";